import { appendShareParams, buildEnglishIqResultWebUrl } from '@repo/config';
import { DEFAULT_LOCALE } from '@repo/web-chrome/i18n';

interface IBuildEnglishIqV2ShareUrlParams {
  locale: string;
  referrerUserId?: string | null;
  shareId: string;
}

export function buildEnglishIqV2ShareUrl({
  locale,
  referrerUserId,
  shareId,
}: IBuildEnglishIqV2ShareUrlParams): string {
  const localeArgument = locale === DEFAULT_LOCALE ? undefined : locale;
  return appendShareParams(buildEnglishIqResultWebUrl(shareId, localeArgument), {
    campaign: 'english_iq_result',
    content: 'result_card',
    ref: referrerUserId,
    source: 'web',
  });
}
